module.exports = __webpack_public_path__ + "img/zhiBack.baaab3e8.png";